<app-dialog-title
  [title]="'delegate.title-dialog' | translate"
  [canClose]="true"
  [isShowLoader]="processing"
  (closeDialog)="close()">
</app-dialog-title>

@if (loading) {
  <app-loading-small></app-loading-small>
} @else {
  <div class="content g-flex-column g-flex--align-center g-flex--justify-center">
    <div class="content-text app-btn_font-size">
      {{ 'delegate.balance' | translate }} {{ delegatorBalance.toFixed(6) }} {{ symbolNetworkCoin() }}. <br />
    </div>

    @if (isEnoughBalanceOnDelegator() && !isDelegatorOutOfDate()) {
      <div class="controls g-flex-column g-flex--align-center">
        <button
          class="app-btn-blue-3 g-flex g-flex--align-center g-flex--justify-center"
          (click)="useDelegation()">
          {{ 'delegate.activate' | translate }}
        </button>

        @if (errorMsg !== '') {
          <div class="app-btn_font-size color-red-fire">{{ errorMsg }}</div>
        }
      </div>
    } @else {
      <button
        class="app-btn-blue-3 g-flex g-flex--align-center g-flex--justify-center"
        (click)="goToSettings()">
        {{ 'delegate.settings' | translate }}
      </button>

      <app-scratch
        class="scratch"
        backgroundType="middle">
      </app-scratch>

      @if (!isEnoughBalanceOnDelegator()) {
        <div class="content-text app-btn_font-size color-red-fire">{{ 'delegate.low' | translate }}</div>
      }
      @if (isDelegatorOutOfDate()) {
        <div class="content-text app-btn_font-size color-red-fire">{{ 'delegate.out-date' | translate }}</div>
      }
    }
  </div>
}
